import { combine, createEvent, sample } from 'effector'
import { register } from '~/core/repository'
import { liveEventsPurchasedEntityModel } from '~/entities/live-events/purchased'
import { model as sessionModel } from '~/entities/session'
import { nay } from '~/shared/helpers'
import { libraryGridPurchasedLiveEventsWidget } from '~/widgets/library/grid/purchased/liveEvents'
import { $libraryPurchasedLiveEventsTranslations } from './translations'

export const initLibraryPurchasedLiveEventsPage = createEvent()
export const leftLibraryPurchasedLiveEventsPage = createEvent()

sample({
  clock: initLibraryPurchasedLiveEventsPage,
  target: libraryGridPurchasedLiveEventsWidget.loadGridPurchasedLiveEvents,
})

export const $isLibraryPurchasedLiveEventsEmptyPage = combine(
  liveEventsPurchasedEntityModel.$purchasedLiveEventsGrid,
  (purchasedLiveEventsGrid) =>
    purchasedLiveEventsGrid && !purchasedLiveEventsGrid.content.length
)

sample({
  source: leftLibraryPurchasedLiveEventsPage,
  target: liveEventsPurchasedEntityModel.resetPurchasedLiveEventsGrid,
})

sample({
  source: sessionModel.$authenticated,
  filter: nay,
  target: liveEventsPurchasedEntityModel.resetPurchasedLiveEventsGrid,
})

register(
  $libraryPurchasedLiveEventsTranslations,
  '$libraryPurchasedLiveEventsTranslations'
)
register(
  liveEventsPurchasedEntityModel.$purchasedLiveEventsGridFormatted,
  '$library/purchased/liveEvents/purchasedLiveEventsGridFormatted'
)
register(
  $isLibraryPurchasedLiveEventsEmptyPage,
  '$isLibraryPurchasedLiveEventsEmptyPage'
)
register(
  libraryGridPurchasedLiveEventsWidget.loadMoreGridPurchasedLiveEvents,
  'loadMoreGridPurchasedLiveEvents'
)
